import React, { useRef } from "react";
import Slider from "react-slick";
import Riyadh from '../../assets/Riyadh.jpg'
import Dubai from '../../assets/UAE.jpg'
import './BusListingHome.css'

const BuslistingHomeSlider = () => {

    const settings = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        // speed: 1000,
        arrows: false,
        dots: false,
        pauseOnHover: false,
    };

    return (
        <div style={{ width: "100%", height: "100%" }}>
            <Slider  {...settings} className="homeImgSliderBack">
                <div className="imageSliderHome">
                    <div className="imageSliderHomeInnerText">
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <h1 className="title-home">
                                Explore Saudi Arabia !!!
                            </h1>
                            <p className="subtitle-home">
                                Visit amazing places from Desert Dreams to Urban Elegance...
                            </p>
                        </div>
                    </div>
                    <img
                        src={Riyadh}
                        alt="Riyadh"
                        className="imageSliderHomeInner"
                    />
                </div>
                <div className="imageSliderHome">
                    <div className="imageSliderHomeInnerText">
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <h1 className="title-home">
                                Explore UAE !!!
                            </h1>
                            <p className="subtitle-home">
                                Explore the Emirates by Bus – Easy, Fast, Online...
                            </p>
                        </div>
                    </div>
                    <img
                        src={Dubai}
                        alt="Dubai"
                        className="imageSliderHomeInner"
                    />
                </div>

            </Slider>
        </div>
    )
}

export default BuslistingHomeSlider
